//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {createNamespacedHelpers} from 'vuex'

const {mapState: mapTransition} = createNamespacedHelpers('transition')
const {mapState: mapCommonState} = createNamespacedHelpers('common')
export default {
    computed: {
        ...mapTransition({
            direction: state => state.direction
        }),
        ...mapCommonState({
            isLoading: state => state.isLoading
        }),
        // 页面切换的动画效果
        viewTransition() {
            if (!this.direction) return ''
            return 'vux-pop-' + (this.direction === 'forward' ? 'in' : 'out')
        }
    },
    data() {
        return {
            isRouterAlive: true,
            showTokenButton: process.env.NODE_ENV === 'development',
            cachePage: 'undefined'
        }
    },
    methods: {
        reload() {
            this.isRouterAlive = false
            this.$nextTick(() => (this.isRouterAlive = true))
        }
    }
}



// WEBPACK FOOTER //
// ./src/App.vue